import React from 'react';

import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { Uplift } from '@/features/details/summary/uplift-badge';

export function MetVal({
  value,
  suffix,
  prefix,
  uplift,
  showUplift,
  id,
  hideTooltip,
}: {
  value: string;
  suffix?: string;
  prefix?: string;
  id: string;
  uplift: number;
  showUplift?: boolean;
  hideTooltip?: boolean;
}) {
  return (
    <MetricValue>
      <Relative data-tip data-for={id}>
        {prefix}
        {value}
        {suffix}
        <Uplift value={uplift} show={showUplift && uplift !== 0} />
      </Relative>
      <ReactTooltip
        className="uplift-tooltip"
        place="right"
        id={id}
        arrowColor="transparent"
      >
        <Uplift value={uplift} show={!hideTooltip} />
      </ReactTooltip>
    </MetricValue>
  );
}

export const Relative = styled.span`
  position: relative;
`;
export const MetricValue = styled.div`
  text-transform: uppercase;
  font-family: Inter, serif;
  font-weight: bold;
  font-size: 1.3rem;
  color: #354452;
  text-align: start;
`;
